import { useCallback } from 'react'
import { useFilteredTasks } from './useFilteredTasks'
import type { TaskDocument } from '@/lib/db/rxdb/schemas/task'

/**
 * Hook that returns sub-tasks for a given parent task.
 * Uses the shared useFilteredTasks pattern for consistency.
 */
export function useSubTasks(
  parentId: string | null | undefined,
  envId: string | null | undefined,
) {
  const predicate = useCallback(
    (task: TaskDocument) => {
      if (!parentId || !envId) return false
      return (
        task.parentId === parentId &&
        task.envId === envId &&
        !task.isArchived
      )
    },
    [parentId, envId],
  )

  const { tasks, isLoading } = useFilteredTasks({
    predicate,
    needsStatuses: false,
  })

  // Sort by sortOrder if available, otherwise by createdAt
  const subTasks = [...tasks].sort((a, b) => {
    if (a.sortOrder && b.sortOrder) {
      return a.sortOrder.localeCompare(b.sortOrder)
    }
    return a.createdOn - b.createdOn
  })

  return {
    subTasks,
    isLoading,
  }
}
